import { Theme } from '../types';

export const THEMES: Theme[] = [
    {
        name: 'Innova Clean (Default)',
        id: 'innova-clean',
        colors: {
            50: '#f0f9ff',
            100: '#e0f2fe',
            200: '#bae6fd',
            300: '#7dd3fc',
            400: '#38bdf8',
            500: '#0ea5e9',
            600: '#0284c7',
            700: '#0369a1',
            800: '#075985',
            900: '#0c4a6e',
            950: '#082f49',
        }
    },
    {
        name: 'Nature Fresh',
        id: 'nature-fresh',
        colors: {
            50: '#f0fdf4',
            100: '#dcfce7',
            200: '#bbf7d0',
            300: '#86efac',
            400: '#4ade80',
            500: '#22c55e',
            600: '#16a34a',
            700: '#15803d',
            800: '#166534',
            900: '#14532d',
            950: '#052e16',
        }
    },
    {
        name: 'Sunset Glow',
        id: 'sunset-glow',
        colors: {
            50: '#fff7ed',
            100: '#ffedd5',
            200: '#fed7aa',
            300: '#fdba74',
            400: '#fb923c',
            500: '#f97316',
            600: '#ea580c',
            700: '#c2410c',
            800: '#9a3412',
            900: '#7c2d12',
            950: '#431407',
        }
    },
    {
        name: 'Royal Clean',
        id: 'royal-clean',
        colors: {
            50: '#f5f3ff',
            100: '#ede9fe',
            200: '#ddd6fe',
            300: '#c4b5fd',
            400: '#a78bfa',
            500: '#8b5cf6',
            600: '#7c3aed',
            700: '#6d28d9',
            800: '#5b21b6',
            900: '#4c1d95',
            950: '#2e1065',
        }
    },
    {
        name: 'Midnight Pro',
        id: 'midnight-pro',
        colors: {
            50: '#f8fafc',
            100: '#f1f5f9',
            200: '#e2e8f0',
            300: '#cbd5e1',
            400: '#94a3b8',
            500: '#64748b',
            600: '#475569',
            700: '#334155',
            800: '#1e293b',
            900: '#0f172a',
            950: '#020617',
        }
    },
    {
        name: 'Latino Tech',
        id: 'latino-tech',
        colors: {
            50: '#effcf6',   // Minty light
            100: '#ccebe4',
            200: '#99d6cb',
            300: '#66c1b3',
            400: '#3aa89b',
            500: '#136F63',  // Primary Brand
            600: '#0f5b51',
            700: '#0c4840',
            800: '#083630',
            900: '#052420',
            950: '#102A43',  // Deep Navy Brand
        }
    }
];

export const DEFAULT_THEME_ID = 'innova-clean';
